let setLoaderFunc = () => {};
let count = 0;
let timeout = null;

export const loader = {
  set: setter => { setLoaderFunc = setter; },

  start: () => {
    count++;
    if (count === 1) {
      timeout = setTimeout(() => setLoaderFunc(true), 200); 
    }
  },

  stop: () => {
    count = Math.max(0, count - 1);
    if (count === 0) {
      clearTimeout(timeout);
      setLoaderFunc(false);
    }
  }
};
